"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _ArrowRight = _interopRequireDefault(require("@rsuite/icon-font/lib/direction/ArrowRight"));

// Generated by script, don't edit it please.
var ArrowRight = (0, _createSvgIcon["default"])({
  as: _ArrowRight["default"],
  ariaLabel: 'arrow right',
  category: 'direction',
  displayName: 'ArrowRight'
});
var _default = ArrowRight;
exports["default"] = _default;
module.exports = exports.default;